"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Warnings = exports.Layout = exports.ButtonGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Button = _interopRequireDefault(require("../Button"));
var Warnings = exports.Warnings = function Warnings(_ref) {
  var recoveryMethod = _ref.recoveryMethod,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-red text-sm mt-2 dark:font-thin"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "recoveryMethod.warnings.".concat(recoveryMethod)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "font-bold",
    onClick: onClick
  })));
};
var ButtonGroup = exports.ButtonGroup = function ButtonGroup(_ref2) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'primary' : _ref2$color,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$isLoading = _ref2.isLoading,
    isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
    onClose = _ref2.onClose,
    onConfirm = _ref2.onConfirm,
    children = _ref2.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", null, onClose && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: isLoading,
    type: "button",
    color: "secondary",
    onClick: onClose,
    className: "w-32 mr-6"
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "submit",
    disabled: disabled || isLoading,
    color: color,
    onClick: onConfirm,
    className: "w-32"
  }, children));
};
var Layout = exports.Layout = function Layout(_ref3) {
  var title = _ref3.title,
    subtitle = _ref3.subtitle,
    children = _ref3.children,
    actions = _ref3.actions;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-between p-8 h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-3xl font-bold"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-gray-light text-lg font-semibold"
  }, subtitle)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow mb-10"
  }, children), /*#__PURE__*/_react["default"].createElement("div", null, actions));
};
//# sourceMappingURL=components.js.map